var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag-svgrepo-com 1",
    clipPath: "url(#clip0_724_868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.90557 3.90557H3.91312M6.5184 0.849121H4.47176C3.20372 0.849121 2.56969 0.849121 2.08537 1.0959C1.65934 1.31297 1.31297 1.65934 1.0959 2.08537C0.849121 2.56969 0.849121 3.20372 0.849121 4.47176V6.5184C0.849121 7.07214 0.849121 7.34905 0.91168 7.60965C0.967144 7.84067 1.05862 8.0615 1.18277 8.26414C1.32278 8.49259 1.51858 8.68837 1.91017 9.07999L5.45734 12.6272C6.35395 13.5238 6.80233 13.9721 7.31923 14.1401C7.77403 14.2878 8.26384 14.2878 8.71863 14.1401C9.23554 13.9721 9.68391 13.5238 10.5805 12.6272L12.6272 10.5805C13.5238 9.68391 13.9721 9.23554 14.1401 8.71863C14.2878 8.26384 14.2878 7.77403 14.1401 7.31923C13.9721 6.80233 13.5238 6.35395 12.6272 5.45734L9.07999 1.91017C8.68837 1.51858 8.49259 1.32278 8.26414 1.18277C8.0615 1.05862 7.84067 0.967144 7.60965 0.91168C7.34905 0.849121 7.07214 0.849121 6.5184 0.849121ZM4.28293 3.90557C4.28293 4.11399 4.11399 4.28293 3.90557 4.28293C3.69717 4.28293 3.52822 4.11399 3.52822 3.90557C3.52822 3.69717 3.69717 3.52822 3.90557 3.52822C4.11399 3.52822 4.28293 3.69717 4.28293 3.90557Z",
    stroke: "#9F9F9F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.958391e21abba5e274c916fb49c55398.svg";
export { ForwardRef as ReactComponent };